import React from 'react';
import { useTranslation } from 'react-i18next';

interface LabelPreviewProps {
  imageUrl: string;
  isLoading: boolean;
  error: string;
}

export const LabelPreview: React.FC<LabelPreviewProps> = ({
  imageUrl,
  isLoading,
  error,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {/* Visual Label Preview - Using Labelary API via Backend */}
      <div className="bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg p-4 flex items-center justify-center overflow-auto">
        <div
          className="w-full rounded bg-white flex items-center justify-center"
          style={{
            aspectRatio: '3/2',
            maxWidth: '900px',
            maxHeight: '600px',
          }}
        >
          {isLoading ? (
            <div className="text-gray-500 text-sm">
              {t('common.loading', { defaultValue: 'Loading...' })}
            </div>
          ) : error ? (
            <div className="text-center text-red-600 text-sm px-4">
              <p className="font-medium mb-2">
                {t('labelPrinting.previewError')}
              </p>
              <p className="text-xs">{error}</p>
            </div>
          ) : imageUrl ? (
            <img
              src={imageUrl}
              alt="Label preview"
              className="w-full h-full object-contain rounded"
            />
          ) : (
            <div className="text-center text-gray-500 text-sm">
              <p className="font-mono text-xs mb-2 text-gray-400">
                {t('labelPrinting.previewNote', {
                  defaultValue: 'Label Preview (3x2 inches)',
                })}
              </p>
              <p className="text-xs">
                {t('labelPrinting.noPreview', {
                  defaultValue: 'Click Preview to see label',
                })}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
